import React from 'react';
import { Dropdown, DropdownProps } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { PaymentStatus } from '../../app/models/PaymentStatus';

interface Props extends Omit<DropdownProps, 'options' | 'value' | 'onChange'> {
  value: number;
  onChange: (value: number) => void;
}

const PaymentStatusSelector: React.FC<Props> = ({ value, onChange, ...rest }) => {
  const { t } = useTranslation();

  const paymentStatusOptions = [
    {
      key: PaymentStatus.NotPaid,
      text: t('payment.notPaid'),
      value: PaymentStatus.NotPaid,
      icon: 'clock outline',
      label: { color: 'grey', empty: true, circular: true }
    },
    {
      key: PaymentStatus.PaidByCard,
      text: t('payment.paidByCard'),
      value: PaymentStatus.PaidByCard,
      icon: 'credit card',
      label: { color: 'blue', empty: true, circular: true }
    },
    {
      key: PaymentStatus.PaidWithCash,
      text: t('payment.paidWithCash'),
      value: PaymentStatus.PaidWithCash,
      icon: 'money bill alternate',
      label: { color: 'green', empty: true, circular: true }
    }
  ];

  return (
    <Dropdown
      selection
      options={paymentStatusOptions}
      value={value}
      onChange={(_, data) => onChange(data.value as number)}
      {...rest}
    />
  );
};

export default PaymentStatusSelector;